import React from "react";
import {TitleContainer} from "./title.styles.js";
function Title({
  children,
  tag = "h1",
  bold = true,
  size = "xl"
}) {
  return /* @__PURE__ */ React.createElement(TitleContainer, {
    tag,
    bold,
    size,
    color: "var(--primaryColor)"
  }, children);
}
export default /* @__PURE__ */ React.memo(Title);
